module.exports = __webpack_public_path__ + "public/images/modals/netw-start-conversation-mobile.3b3991716a04f9a31f77857ed4ea64ba.png";